// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Cormorant+Garamond:ital,wght@0,400;0,500;0,600;1,400;1,500&family=Montserrat:wght@300;400;500;600&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* =========================
   FOOTER
========================= */

.footer {
  --footer-pink: #e6007e;
  --footer-pink-light: #ff4da6;
  --footer-pearl: #f8f5f2;
  --footer-gray: #a59da1;

  position: relative;

  z-index: 20;

  padding:
    100px
    max(6%, calc((100vw - 1400px) / 2))
    32px;

  overflow: hidden;

  color: var(--footer-pearl);

  background:
    radial-gradient(
      circle at 10% 0%,
      rgba(230, 0, 126, 0.11),
      transparent 28%
    ),
    radial-gradient(
      circle at 95% 100%,
      rgba(230, 0, 126, 0.08),
      transparent 30%
    ),
    linear-gradient(
      135deg,
      #070707 0%,
      #0b0a0b 45%,
      #151014 100%
    );

  font-family: "Montserrat", sans-serif;
}


/* =========================
   TOP
========================= */

.footer-top {
  display: grid;

  grid-template-columns:
    1.7fr
    0.8fr
    0.9fr
    1fr;

  gap: 70px;

  max-width: 1400px;

  margin: 0 auto;

  padding-bottom: 80px;
}


/* =========================
   BRAND
========================= */

.footer-brand {
  max-width: 470px;
}

.footer-eyebrow {
  margin: 0 0 25px;

  color: var(--footer-pink);

  font-size: 0.58rem;
  font-weight: 500;

  letter-spacing: 4px;

  text-transform: uppercase;
}

.footer-brand h2 {
  margin: 0;

  color: var(--footer-pearl);

  font-family: "Cormorant Garamond", serif;

  font-size: clamp(3rem, 4.5vw, 5.3rem);
  font-weight: 400;

  line-height: 0.9;

  letter-spacing: -2px;
}

.footer-brand h2 em {
  color: var(--footer-pink);

  font-weight: 400;
}

.footer-brand-description {
  max-width: 400px;

  margin: 30px 0 0;

  color: var(--footer-gray);

  font-size: 0.72rem;
  font-weight: 300;

  line-height: 1.9;
}


/* =========================
   COLUMNS
========================= */

.footer-column {
  display: flex;
  flex-direction: column;
  align-items: flex-start;

  gap: 16px;
}

.footer-column h4 {
  margin: 5px 0 16px;

  color: var(--footer-pink);

  font-size: 0.56rem;
  font-weight: 600;

  letter-spacing: 3px;

  text-transform: uppercase;
}

.footer-column > a {
  position: relative;

  color: #d1c9cd;

  text-decoration: none;

  font-family: "Cormorant Garamond", serif;

  font-size: 1.1rem;
  font-weight: 400;

  transition:
    color 0.3s ease,
    transform 0.3s ease;
}

.footer-column > a:not(.footer-social)::after {
  content: "";

  position: absolute;

  left: 0;
  bottom: -4px;

  width: 0;
  height: 1px;

  background: var(--footer-pink);

  transition: width 0.3s ease;
}

.footer-column > a:hover {
  color: #ffffff;

  transform: translateX(3px);
}

.footer-column > a:not(.footer-social):hover::after {
  width: 100%;
}


/* =========================
   VIRTUAL LOCATION
========================= */

.footer-location {
  display: flex;
  align-items: flex-start;

  gap: 11px;

  margin-top: 14px;

  padding-top: 20px;

  width: 100%;

  border-top:
    1px solid
    rgba(255, 255, 255, 0.08);
}

.footer-status-dot {
  width: 7px;
  height: 7px;

  margin-top: 7px;

  flex-shrink: 0;

  border-radius: 50%;

  background: var(--footer-pink);

  box-shadow:
    0 0 12px
    rgba(230, 0, 126, 0.65);
}

.footer-location p {
  margin: 0;

  color: #ffffff;

  font-family: "Cormorant Garamond", serif;

  font-size: 1rem;
}

.footer-location small {
  display: block;

  margin-top: 4px;

  color: #777075;

  font-family: "Montserrat", sans-serif;

  font-size: 0.53rem;

  letter-spacing: 0.5px;
}


/* =========================
   SOCIAL LINKS
========================= */

.footer-social {
  width: 100%;

  display: flex;
  align-items: center;
  justify-content: space-between;

  padding: 0 0 12px;

  border-bottom:
    1px solid
    rgba(255, 255, 255, 0.09);
}

.footer-social span {
  color: var(--footer-pink);

  font-family: "Montserrat", sans-serif;

  font-size: 0.8rem;

  transition:
    transform 0.3s ease;
}

.footer-social:hover span {
  transform:
    translate(3px, -3px);
}

.footer-social-message {
  max-width: 250px;

  margin: 8px 0 0;

  color: #777075;

  font-size: 0.61rem;
  font-weight: 300;

  line-height: 1.8;
}


/* =========================
   BOTTOM
========================= */

.footer-bottom {
  max-width: 1400px;

  margin: 0 auto;

  padding-top: 28px;

  display: flex;
  align-items: center;
  justify-content: space-between;

  gap: 30px;

  border-top:
    1px solid
    rgba(255, 255, 255, 0.1);
}

.footer-bottom p {
  margin: 0;

  color: #6f686c;

  font-size: 0.5rem;
  font-weight: 400;

  letter-spacing: 1px;

  text-transform: uppercase;
}

.footer-bottom-links {
  display: flex;
  align-items: center;

  gap: 24px;
}

.footer-bottom-links a {
  color: #777075;

  text-decoration: none;
  text-transform: uppercase;

  font-size: 0.49rem;
  font-weight: 500;

  letter-spacing: 1.2px;

  transition:
    color 0.3s ease;
}

.footer-bottom-links a:hover {
  color: var(--footer-pink);
}


/* =========================
   TABLET
========================= */

@media (max-width: 1050px) {

  .footer-top {
    grid-template-columns:
      1.5fr
      1fr
      1fr;

    gap: 55px;
  }

  .footer-brand {
    grid-column: 1 / -1;

    max-width: 600px;
  }

}


/* =========================
   MOBILE
========================= */

@media (max-width: 700px) {

  .footer {
    padding:
      75px
      7%
      30px;
  }

  .footer-top {
    grid-template-columns: 1fr;

    gap: 50px;

    padding-bottom: 55px;
  }

  .footer-brand {
    grid-column: auto;
  }

  .footer-brand h2 {
    font-size:
      clamp(3.3rem, 16vw, 4.6rem);
  }

  .footer-brand-description {
    max-width: 100%;
  }

  .footer-social-message {
    max-width: 100%;
  }

  .footer-bottom {
    flex-direction: column;

    align-items: flex-start;
  }

  .footer-bottom-links {
    flex-wrap: wrap;

    gap: 18px;
  }

}`, "",{"version":3,"sources":["webpack://./src/components/Footer.css"],"names":[],"mappings":"AAGA;;2BAE2B;;AAE3B;EACE,sBAAsB;EACtB,4BAA4B;EAC5B,uBAAuB;EACvB,sBAAsB;;EAEtB,kBAAkB;;EAElB,WAAW;;EAEX;;;QAGM;;EAEN,gBAAgB;;EAEhB,0BAA0B;;EAE1B;;;;;;;;;;;;;;;;KAgBG;;EAEH,qCAAqC;AACvC;;;AAGA;;2BAE2B;;AAE3B;EACE,aAAa;;EAEb;;;;OAIK;;EAEL,SAAS;;EAET,iBAAiB;;EAEjB,cAAc;;EAEd,oBAAoB;AACtB;;;AAGA;;2BAE2B;;AAE3B;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;;EAEhB,yBAAyB;;EAEzB,kBAAkB;EAClB,gBAAgB;;EAEhB,mBAAmB;;EAEnB,yBAAyB;AAC3B;;AAEA;EACE,SAAS;;EAET,0BAA0B;;EAE1B,wCAAwC;;EAExC,qCAAqC;EACrC,gBAAgB;;EAEhB,gBAAgB;;EAEhB,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;;EAEzB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;;EAEhB,gBAAgB;;EAEhB,yBAAyB;;EAEzB,kBAAkB;EAClB,gBAAgB;;EAEhB,gBAAgB;AAClB;;;AAGA;;2BAE2B;;AAE3B;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;;EAEvB,SAAS;AACX;;AAEA;EACE,kBAAkB;;EAElB,yBAAyB;;EAEzB,kBAAkB;EAClB,gBAAgB;;EAEhB,mBAAmB;;EAEnB,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;;EAElB,cAAc;;EAEd,qBAAqB;;EAErB,wCAAwC;;EAExC,iBAAiB;EACjB,gBAAgB;;EAEhB;;uBAEqB;AACvB;;AAEA;EACE,WAAW;;EAEX,kBAAkB;;EAElB,OAAO;EACP,YAAY;;EAEZ,QAAQ;EACR,WAAW;;EAEX,8BAA8B;;EAE9B,2BAA2B;AAC7B;;AAEA;EACE,cAAc;;EAEd,0BAA0B;AAC5B;;AAEA;EACE,WAAW;AACb;;;AAGA;;2BAE2B;;AAE3B;EACE,aAAa;EACb,uBAAuB;;EAEvB,SAAS;;EAET,gBAAgB;;EAEhB,iBAAiB;;EAEjB,WAAW;;EAEX;;6BAE2B;AAC7B;;AAEA;EACE,UAAU;EACV,WAAW;;EAEX,eAAe;;EAEf,cAAc;;EAEd,kBAAkB;;EAElB,8BAA8B;;EAE9B;;2BAEyB;AAC3B;;AAEA;EACE,SAAS;;EAET,cAAc;;EAEd,wCAAwC;;EAExC,eAAe;AACjB;;AAEA;EACE,cAAc;;EAEd,eAAe;;EAEf,cAAc;;EAEd,qCAAqC;;EAErC,kBAAkB;;EAElB,qBAAqB;AACvB;;;AAGA;;2BAE2B;;AAE3B;EACE,WAAW;;EAEX,aAAa;EACb,mBAAmB;EACnB,8BAA8B;;EAE9B,iBAAiB;;EAEjB;;6BAE2B;AAC7B;;AAEA;EACE,yBAAyB;;EAEzB,qCAAqC;;EAErC,iBAAiB;;EAEjB;uBACqB;AACvB;;AAEA;EACE;wBACsB;AACxB;;AAEA;EACE,gBAAgB;;EAEhB,eAAe;;EAEf,cAAc;;EAEd,kBAAkB;EAClB,gBAAgB;;EAEhB,gBAAgB;AAClB;;;AAGA;;2BAE2B;;AAE3B;EACE,iBAAiB;;EAEjB,cAAc;;EAEd,iBAAiB;;EAEjB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;;EAE9B,SAAS;;EAET;;4BAE0B;AAC5B;;AAEA;EACE,SAAS;;EAET,cAAc;;EAEd,iBAAiB;EACjB,gBAAgB;;EAEhB,mBAAmB;;EAEnB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;;EAEnB,SAAS;AACX;;AAEA;EACE,cAAc;;EAEd,qBAAqB;EACrB,yBAAyB;;EAEzB,kBAAkB;EAClB,gBAAgB;;EAEhB,qBAAqB;;EAErB;mBACiB;AACnB;;AAEA;EACE,yBAAyB;AAC3B;;;AAGA;;2BAE2B;;AAE3B;;EAEE;IACE;;;SAGK;;IAEL,SAAS;EACX;;EAEA;IACE,mBAAmB;;IAEnB,gBAAgB;EAClB;;AAEF;;;AAGA;;2BAE2B;;AAE3B;;EAEE;IACE;;;UAGM;EACR;;EAEA;IACE,0BAA0B;;IAE1B,SAAS;;IAET,oBAAoB;EACtB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE;iCAC6B;EAC/B;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,sBAAsB;;IAEtB,uBAAuB;EACzB;;EAEA;IACE,eAAe;;IAEf,SAAS;EACX;;AAEF","sourcesContent":["@import url(\"https://fonts.googleapis.com/css2?family=Cormorant+Garamond:ital,wght@0,400;0,500;0,600;1,400;1,500&family=Montserrat:wght@300;400;500;600&display=swap\");\n\n\n/* =========================\n   FOOTER\n========================= */\n\n.footer {\n  --footer-pink: #e6007e;\n  --footer-pink-light: #ff4da6;\n  --footer-pearl: #f8f5f2;\n  --footer-gray: #a59da1;\n\n  position: relative;\n\n  z-index: 20;\n\n  padding:\n    100px\n    max(6%, calc((100vw - 1400px) / 2))\n    32px;\n\n  overflow: hidden;\n\n  color: var(--footer-pearl);\n\n  background:\n    radial-gradient(\n      circle at 10% 0%,\n      rgba(230, 0, 126, 0.11),\n      transparent 28%\n    ),\n    radial-gradient(\n      circle at 95% 100%,\n      rgba(230, 0, 126, 0.08),\n      transparent 30%\n    ),\n    linear-gradient(\n      135deg,\n      #070707 0%,\n      #0b0a0b 45%,\n      #151014 100%\n    );\n\n  font-family: \"Montserrat\", sans-serif;\n}\n\n\n/* =========================\n   TOP\n========================= */\n\n.footer-top {\n  display: grid;\n\n  grid-template-columns:\n    1.7fr\n    0.8fr\n    0.9fr\n    1fr;\n\n  gap: 70px;\n\n  max-width: 1400px;\n\n  margin: 0 auto;\n\n  padding-bottom: 80px;\n}\n\n\n/* =========================\n   BRAND\n========================= */\n\n.footer-brand {\n  max-width: 470px;\n}\n\n.footer-eyebrow {\n  margin: 0 0 25px;\n\n  color: var(--footer-pink);\n\n  font-size: 0.58rem;\n  font-weight: 500;\n\n  letter-spacing: 4px;\n\n  text-transform: uppercase;\n}\n\n.footer-brand h2 {\n  margin: 0;\n\n  color: var(--footer-pearl);\n\n  font-family: \"Cormorant Garamond\", serif;\n\n  font-size: clamp(3rem, 4.5vw, 5.3rem);\n  font-weight: 400;\n\n  line-height: 0.9;\n\n  letter-spacing: -2px;\n}\n\n.footer-brand h2 em {\n  color: var(--footer-pink);\n\n  font-weight: 400;\n}\n\n.footer-brand-description {\n  max-width: 400px;\n\n  margin: 30px 0 0;\n\n  color: var(--footer-gray);\n\n  font-size: 0.72rem;\n  font-weight: 300;\n\n  line-height: 1.9;\n}\n\n\n/* =========================\n   COLUMNS\n========================= */\n\n.footer-column {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n\n  gap: 16px;\n}\n\n.footer-column h4 {\n  margin: 5px 0 16px;\n\n  color: var(--footer-pink);\n\n  font-size: 0.56rem;\n  font-weight: 600;\n\n  letter-spacing: 3px;\n\n  text-transform: uppercase;\n}\n\n.footer-column > a {\n  position: relative;\n\n  color: #d1c9cd;\n\n  text-decoration: none;\n\n  font-family: \"Cormorant Garamond\", serif;\n\n  font-size: 1.1rem;\n  font-weight: 400;\n\n  transition:\n    color 0.3s ease,\n    transform 0.3s ease;\n}\n\n.footer-column > a:not(.footer-social)::after {\n  content: \"\";\n\n  position: absolute;\n\n  left: 0;\n  bottom: -4px;\n\n  width: 0;\n  height: 1px;\n\n  background: var(--footer-pink);\n\n  transition: width 0.3s ease;\n}\n\n.footer-column > a:hover {\n  color: #ffffff;\n\n  transform: translateX(3px);\n}\n\n.footer-column > a:not(.footer-social):hover::after {\n  width: 100%;\n}\n\n\n/* =========================\n   VIRTUAL LOCATION\n========================= */\n\n.footer-location {\n  display: flex;\n  align-items: flex-start;\n\n  gap: 11px;\n\n  margin-top: 14px;\n\n  padding-top: 20px;\n\n  width: 100%;\n\n  border-top:\n    1px solid\n    rgba(255, 255, 255, 0.08);\n}\n\n.footer-status-dot {\n  width: 7px;\n  height: 7px;\n\n  margin-top: 7px;\n\n  flex-shrink: 0;\n\n  border-radius: 50%;\n\n  background: var(--footer-pink);\n\n  box-shadow:\n    0 0 12px\n    rgba(230, 0, 126, 0.65);\n}\n\n.footer-location p {\n  margin: 0;\n\n  color: #ffffff;\n\n  font-family: \"Cormorant Garamond\", serif;\n\n  font-size: 1rem;\n}\n\n.footer-location small {\n  display: block;\n\n  margin-top: 4px;\n\n  color: #777075;\n\n  font-family: \"Montserrat\", sans-serif;\n\n  font-size: 0.53rem;\n\n  letter-spacing: 0.5px;\n}\n\n\n/* =========================\n   SOCIAL LINKS\n========================= */\n\n.footer-social {\n  width: 100%;\n\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n\n  padding: 0 0 12px;\n\n  border-bottom:\n    1px solid\n    rgba(255, 255, 255, 0.09);\n}\n\n.footer-social span {\n  color: var(--footer-pink);\n\n  font-family: \"Montserrat\", sans-serif;\n\n  font-size: 0.8rem;\n\n  transition:\n    transform 0.3s ease;\n}\n\n.footer-social:hover span {\n  transform:\n    translate(3px, -3px);\n}\n\n.footer-social-message {\n  max-width: 250px;\n\n  margin: 8px 0 0;\n\n  color: #777075;\n\n  font-size: 0.61rem;\n  font-weight: 300;\n\n  line-height: 1.8;\n}\n\n\n/* =========================\n   BOTTOM\n========================= */\n\n.footer-bottom {\n  max-width: 1400px;\n\n  margin: 0 auto;\n\n  padding-top: 28px;\n\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n\n  gap: 30px;\n\n  border-top:\n    1px solid\n    rgba(255, 255, 255, 0.1);\n}\n\n.footer-bottom p {\n  margin: 0;\n\n  color: #6f686c;\n\n  font-size: 0.5rem;\n  font-weight: 400;\n\n  letter-spacing: 1px;\n\n  text-transform: uppercase;\n}\n\n.footer-bottom-links {\n  display: flex;\n  align-items: center;\n\n  gap: 24px;\n}\n\n.footer-bottom-links a {\n  color: #777075;\n\n  text-decoration: none;\n  text-transform: uppercase;\n\n  font-size: 0.49rem;\n  font-weight: 500;\n\n  letter-spacing: 1.2px;\n\n  transition:\n    color 0.3s ease;\n}\n\n.footer-bottom-links a:hover {\n  color: var(--footer-pink);\n}\n\n\n/* =========================\n   TABLET\n========================= */\n\n@media (max-width: 1050px) {\n\n  .footer-top {\n    grid-template-columns:\n      1.5fr\n      1fr\n      1fr;\n\n    gap: 55px;\n  }\n\n  .footer-brand {\n    grid-column: 1 / -1;\n\n    max-width: 600px;\n  }\n\n}\n\n\n/* =========================\n   MOBILE\n========================= */\n\n@media (max-width: 700px) {\n\n  .footer {\n    padding:\n      75px\n      7%\n      30px;\n  }\n\n  .footer-top {\n    grid-template-columns: 1fr;\n\n    gap: 50px;\n\n    padding-bottom: 55px;\n  }\n\n  .footer-brand {\n    grid-column: auto;\n  }\n\n  .footer-brand h2 {\n    font-size:\n      clamp(3.3rem, 16vw, 4.6rem);\n  }\n\n  .footer-brand-description {\n    max-width: 100%;\n  }\n\n  .footer-social-message {\n    max-width: 100%;\n  }\n\n  .footer-bottom {\n    flex-direction: column;\n\n    align-items: flex-start;\n  }\n\n  .footer-bottom-links {\n    flex-wrap: wrap;\n\n    gap: 18px;\n  }\n\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
